<template>
    <el-dialog
        class="sub-window-dialog sub-history-dialog"
        :width="windowWidth > 600 ? '563px' : '100%'"
        :top="windowWidth > 600 ? '15vh' : '0'"
        :append-to-body="true"
        :visible="visible"
        @close="$emit('close')"
    >
        <button class="btn popup__close" @click.prevent="$emit('close')">
            <i class="el-icon-close"></i>
        </button>

        <template>
            <div class="sub-window-container">
                <h3 class="sub-window-title">
                    {{ $lang('subscriptionHistory.title') }}
                </h3>
                <div class="sub-history-container">
                    <ul
                        v-for="(payments, month) in groupedPayments"
                        :key="month"
                        class="sub-history-ul"
                    >
                        <h4 class="sub-history-title">{{ month }}</h4>
                    <li
                        v-for="payment in payments"
                        :key="payment.id"
                        class="sub-history-li"
                    >
                        <p class="sub-history-text">
                            <span v-html="payment.title"></span>
                            <span class="sub-history-price">-{{ Number(payment.price).toLocaleString('ru-RU') }} {{ $lang('subscriptionHistory.rub') }} </span>
                        </p>
                        <p class="sub-history-text sub-history-text--payment">
                            {{ $lang('subscriptionHistory.debited') }} {{ new Date(payment.active_at).toLocaleDateString('ru-RU') }}
                        </p>
                    </li>
                    </ul>
                </div>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default {
    name: "SubscriptionWindow",
    data() {
        return {
            subscriptionTypes: window.laravel.subscriptionTypes,
            showHistoryModal: false,
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('subscription', [
            'paymentHistory'
        ]),
        groupedPayments() {
            const result = {};
            const now = new Date();
            const currentYear = now.getFullYear();

            this.paymentHistory?.subscriptions?.forEach(sub => {
                sub.payments?.forEach(payment => {
                    const date = new Date(payment.created_at);
                    const monthIndex = date.getMonth();
                    const month = Vue.prototype.$lang('month' + (monthIndex + 1));
                    const year = date.getFullYear();
                    const yearWord = Vue.prototype.$lang('subscriptionHistory.year_word');
                    const key = year === currentYear ? month : `${month} ${year} ${yearWord}`;
                    if (!result[key]) result[key] = [];
                    result[key].push({
                        title: this.getSubscriptionTitle(payment.payment_type_id),
                        price: payment.price,
                        date: date,
                        active_at: payment.created_at
                    });
                });
            });

            Object.keys(result).forEach(key => {
                result[key].sort((a, b) => new Date(b.active_at) - new Date(a.active_at));
            });

            return Object.keys(result)
                .sort((a, b) => {
                    const dateA = result[a][0].date;
                    const dateB = result[b][0].date;
                    return dateB - dateA;
                })
                .reduce((acc, key) => {
                    acc[key] = result[key];
                    return acc;
                }, {});
        },
        capitalize() {
            return (str) => str.charAt(0).toUpperCase() + str.slice(1);
        }
    },
    methods: {
        getSubscriptionTitle(payment_type_id) {
            const type = this.subscriptionTypes.find(t => t.payment_type_id === payment_type_id);
            return type ? this.$lang(type.name) : '';
        }
    },
}
</script>